import React from "react";
import { Link } from "react-router-dom";

const Testimonial = () => {
	return (
		<div className="testimonialWrapper">
			<div className="testimonial-container">
				<div className="content-block">
					<div className="content">
						<img src="/astronOriginal/review ss/01.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/02.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/03.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/04.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/05.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/06.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/07.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/08.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/09.jpeg" alt="astron-testimonial" />
					</div>
					<div className="content">
						<img src="/astronOriginal/review ss/10.jpeg" alt="astron-testimonial" />
					</div>
				</div>
				<div className="new-container">
					<Link
						to="https://www.google.com/maps/place/Astron+Maths+Academy/@21.1679963,72.6418907,12z/data=!4m12!1m2!2m1!1sastron+maths!3m8!1s0x3be04de671dfe92f:0x88ade4c01ff22c1b!8m2!3d21.1679963!4d72.794326!9m1!1b1!15sCgxhc3Ryb24gbWF0aHNaDiIMYXN0cm9uIG1hdGhzkgEUYWZ0ZXJfc2Nob29sX3Byb2dyYW2qAUcQASoQIgxhc3Ryb24gbWF0aHMoADIfEAEiG4yduD3RWwOxD7VmL0AmIJ0BbV7-Rzt118hsjzIQEAIiDGFzdHJvbiBtYXRoc-ABAA!16s%2Fg%2F12hq3z8lv?entry=ttu&g_ep=EgoyMDI1MDUxMi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D"
						target="_blank"
					>
						Know More + | Google Link
					</Link>
				</div>
				<div className="gd"></div>
			</div>
		</div>
	);
};

export default Testimonial;
